export default function InputText({ id, labelText, inputValue,changeHandler }) {
  return (
    <div id={id + "Input"} className="form-input-class">
      <label className="form-label">{labelText} </label>
      <div className="select-form-Input">
        <input
          className="form-control form-select"
          id={"text-" + id + "Input"}
          type="text"
          value={inputValue}
          size="30"
          maxLength="128"
          onChange={changeHandler}
        ></input>
      </div>
    </div>
  );
}
